import { LABELS } from '../../labels.constants'
import { ROUTE_PARTS, URL_PATHS } from '../../routes.constants'

import DashobardIcon from '@mui/icons-material/Dashboard'
import CustomerIcon from '@mui/icons-material/Group'
import InvoiceIcon from '@mui/icons-material/ReceiptLong'
import ProfileIcon from '@mui/icons-material/Person'
import QuoteIcon from '@mui/icons-material/TableView'
import SettingsIcon from '@mui/icons-material/Settings'
import ProductIcon from '@mui/icons-material/Inventory'
import { POLICIES } from 'src/constants/policies.constants'

const REQUIRED_POLICIES = {
  DOCUMENTS: {
    LIST: POLICIES.DOCUMENT.READ,
  },
  CLIENT: {
    LIST: POLICIES.CLIENT.READ,
  },
}

export const MAIN_PAGE_NAV = [
  {
    label: LABELS.DASHOARD,
    path: URL_PATHS.DASHBOARD,
    icon: DashobardIcon,
  },
  {
    label: LABELS.INVOICES,
    path: URL_PATHS.INVOICE_LIST,
    icon: InvoiceIcon,
    policy: REQUIRED_POLICIES.DOCUMENTS.LIST,
  },
  {
    label: LABELS.QUOTES,
    path: URL_PATHS.QUOTE_LIST,
    icon: QuoteIcon,
    policy: REQUIRED_POLICIES.DOCUMENTS.LIST,
  },
  {
    label: LABELS.CLIENTS,
    path: URL_PATHS.CLIENT_LIST,
    icon: CustomerIcon,
    policy: REQUIRED_POLICIES.CLIENT.LIST,
  },
  {
    label: LABELS.CATALOG,
    path: URL_PATHS.PRODUCT_LIST,
    icon: ProductIcon,
  },
]

export const MOBILE_MAIN_NAV = [
  {
    label: LABELS.DASHOARD,
    path: URL_PATHS.DASHBOARD,
    icon: DashobardIcon,
    badge: true,
  },
  {
    label: LABELS.INVOICES,
    path: URL_PATHS.INVOICE_LIST,
    segment: ROUTE_PARTS.INVOICE_LIST,
    icon: InvoiceIcon,
    policy: REQUIRED_POLICIES.DOCUMENTS.LIST,
  },
  {
    label: LABELS.QUOTES,
    segment: ROUTE_PARTS.INVOICE_LIST,
    path: URL_PATHS.QUOTE_LIST,
    icon: QuoteIcon,
    policy: REQUIRED_POLICIES.DOCUMENTS.LIST,
  },
  {
    label: LABELS.CLIENTS,
    segment: ROUTE_PARTS.INVOICE_LIST,
    path: URL_PATHS.CLIENT_LIST,
    icon: CustomerIcon,
    policy: REQUIRED_POLICIES.CLIENT.LIST,
  },
  {
    label: LABELS.CATALOG,
    segment: ROUTE_PARTS.PRODUCT_LIST,
    path: URL_PATHS.PRODUCT_LIST,
    icon: ProductIcon,
  },
]

export const MAIN_MY_NAV = [
  {
    label: LABELS.SETTINGS,
    path: URL_PATHS.SETTINGS,
    icon: SettingsIcon,
  },
  {
    label: LABELS.MY_ACCOUNT,
    path: URL_PATHS.ACCOUNT,
    icon: ProfileIcon,
  },
]

export const MOBILE_MY_NAV = [
  {
    label: LABELS.SETTINGS,
    path: URL_PATHS.SETTINGS,
    icon: SettingsIcon,
  },
  {
    label: LABELS.MY_ACCOUNT,
    path: URL_PATHS.ACCOUNT,
    icon: ProfileIcon,
  },
]
